export const config = {
    BACKEND: 'https://speaker-id.com'
}
